module.exports = __webpack_public_path__ + "static/fonts/Oswald-HeavyItalic.a3bf4f0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-HeavyItalic.ttf
// module id = XiBC
// module chunks = 1